import { useAppSelector } from '../../hooks';
import { FilterColumnStore } from './selected-column.reducer';

export const useSelectedColumnSelector = (tableId: string): FilterColumnStore =>
  useAppSelector(({ selectedColumn }) => selectedColumn[tableId]);
